export const BASE_URL = "https://codebotapi.mobileprogramming.com";

export const INTERVIEW = {
  START: "/statInterview",
  ANSWER: "/userAnswers",
  RESULT: "/candidateResults",
  QUESTION: "/nextQuestion",
};
